import { useMemo } from "react"
import { FileResponse } from "shared/api"
import { Stack, Typography, Chip } from "@mui/material"

import { DialogBase } from "components/dialog"
import { Loading} from "components/controls/loading"
import { Section } from 'components/controls/section'

import { UserRoleChip } from "features/user/components/roleChip"
import { UserResult, useSelfUser } from "interface/user"

import { UserNameForm } from "../form/userName"
import { UserIconForm } from "../form/userIcon"

type EditProfileDialogProps = {
	onChangeUserIcon: (file: FileResponse) => void
	onChangeUserName: (user: UserResult) => void
  onClose: () => void
}
export const EditProfileDialog = ({
  onChangeUserIcon,
  onChangeUserName,
  onClose
}: EditProfileDialogProps) => {
	const userState = useSelfUser()
	const user = useMemo(() => userState.data, [userState])
	if (!user) return <Loading/>
	return (
    <DialogBase
      open
			fullWidth
      maxWidth="md"
      title="ログイン中のユーザー情報"
      body={(
				<Stack direction="row" spacing={2}>
					<UserIconForm
						onChangeUserIcon={onChangeUserIcon}
					/>
					<Stack direction="column">
						<Section label="ユーザー名" labelProps={{ py: 2 }}>
							<UserNameForm
								user={user}
								onChangeUserName={onChangeUserName}
							/>
						</Section>

						<Section label="パスワード" labelProps={{ py: 2 }}>
							<Stack direction="row" spacing={2} alignItems="center">
								<Typography component="div" variant="body1">
									********
								</Typography>
							</Stack>
						</Section>

						<Section label="所属グループ" labelProps={{ py: 2 }}>
							<Stack direction="row" spacing={1}>
								{user.group?.map((group) => (
									<Chip
										key={group.groupId}
										label={group.groupName}
										color="success"
										variant="filled"
									/>
								))}
							</Stack>
						</Section>

						<Section label="ユーザー権限" labelProps={{ py: 2 }}>
							<Stack direction="row" spacing={1}>
								{user.role.map((role, index) => (
									<UserRoleChip key={`${role}-${index}`} role={role}/>
								))}
							</Stack>
						</Section>
					</Stack>
				</Stack>
      )}
			action={{ onClose }}
      onClose={onClose}
    />
  )
}
